import { render, staticRenderFns } from "./CollectedProduct.vue?vue&type=template&id=c4f9b2be&scoped=true&"
import script from "./CollectedProduct.vue?vue&type=script&lang=js&"
export * from "./CollectedProduct.vue?vue&type=script&lang=js&"
import style0 from "./CollectedProduct.vue?vue&type=style&index=0&id=c4f9b2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f9b2be",
  null
  
)

export default component.exports